/** The approved brain-and-orbits mark, generated from assets/branding/orbit-mind-master.png. */
export const ORBIT_LOGO = {
    webMark: '/orbit-mind-logo-v3.webp',
};
//# sourceMappingURL=logo.js.map